import { IFeatureFlags } from '@sennder/senn-node-microfrontend-interfaces'

export const makeCompatibleFeatureFlags = (
  featureFlags: IFeatureFlags
): Record<string, string | boolean> =>
  Object.entries(featureFlags).reduce<Record<string, string | boolean>>(
    (acc, [key, value]) => {
      if (typeof value === 'string' || typeof value === 'boolean') {
        acc[key] = value
      }

      return acc
    },
    {}
  )
